import React, { Component } from 'react';

import Dialog from '../../../raven/modals/dialog';
import MDTCView from './dtcView';

export default class MDTCHistoryModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dtcs: [],
            loading: true
        };
    }

    getRavenDTCs() {
        // perform ajax calls to get it the next state
        let url = "" + this.props.dataStore.prefix1 + "ajaxbig"
                + "?stage=" + this.props.stage
                + "&type=dtc"
                + "&raven=" + this.props.raven.raven_id;

        this.props.dataStore.queryLoop(url, (items) => {
            this.setState({
                dtcs: items,
                loading: false
            });
        });
    }

    componentDidMount() {
        this.getRavenDTCs();
    }

    render() {

        return (
            <Dialog
                size="medium"
                className="test"
                label={this.props.title}
                isOpen={this.props.isOpen}
                onClose={this.props.onClose}
                >
                    <div>
                        <div className="row">
                            <div className="col-12">
                                {
                                    this.state.dtcs && !this.state.loading ? 
                                        this.state.dtcs.length > 0 ?  
                                            <MDTCView 
                                                data={this.state.dtcs} 
                                                /> : 
                                            <p>No DTC Data...</p> :
                                        <p>Loading...</p>
                                }
                            </div>
                        </div>
                    
                    </div>
            </Dialog>
        );
    }

}
